import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';
import './article-card.scss';

export function ArticleCard({ entry, textRight, isLabelHidden }) {
  const { url, image, title, authors, updatedDate, promoLabel, promoURL, promoText } = entry.getAllMetadata();
  return (
    <div className="article-card pt-0_5 mb-1">
      {!isLabelHidden && (
        <div className="promo-label mb-0_5 hidden-md-down">
          {promoLabel && (
            <a href={promoURL} className="h7 text-primary fw-bold text-uppercase">
              {promoLabel}
            </a>
          )}
        </div>
      )}
      <Row>
        <Col xs={{ size: textRight ? 12 : 4 }} md={12}>
          <a className="article-card-link d-block" href={url}>
            <img alt={title} className="article-card-image" src={getFullImageUrl(image, IMAGE_SIZES.md)} />
          </a>
        </Col>
        <Col xs={{ size: textRight ? 12 : 8 }} md={12}>
          <div className="pb-md-0_5">
            {authors && <span className="text-gray-dark disclaimer pe-0_5">{authors}</span>}
            {updatedDate && (
              <div className="text-gray-dark d-inline-block disclaimer sep hidden-md-down">
                <span className="ps-0_5">{updatedDate}</span>
              </div>
            )}
          </div>
          <a href={url} title={title} className="display-5 fw-bold text-gray-darker">
            {title}
          </a>
        </Col>
      </Row>

      <h6 className="hidden-md-down mt-0_25 fw-normal">{promoText}</h6>
    </div>
  );
}

ArticleCard.propTypes = {
  entry: PropTypes.shape({
    url: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    authors: PropTypes.string,
    updatedDate: PropTypes.string,
    promoLabel: PropTypes.string,
    promoURL: PropTypes.string,
    promoText: PropTypes.string,
  }).isRequired,
  textRight: PropTypes.bool,
  isLabelHidden: PropTypes.bool,
};

ArticleCard.defaultProps = {
  textRight: false,
  isLabelHidden: false,
};
